export default "__VITE_ASSET__DAfDYGr7__"